<p-table
  #dt2
  [value]="couponCodes"
  dataKey="id"
  [rows]="10"
  styleClass="p-datatable-users p-datatable-striped"
  [globalFilterFields]="[
    'couponCode',
    'created',
    'expiration',
    'value',
    'status'
  ]"
  [scrollable]="true"
  scrollHeight="1000px"
  dataKey="couponCode"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <span class="p-input-icon-right to-right">
        <p-button
          label="Add Coupon"
          icon="pi pi-user"
          styleClass="p-button-success"
          iconPos="right"
          (onClick)="showAddCoupon()"
        ></p-button>
        <i class="pi pi-search to-right"></i>
        <input
          pInputText
          type="text"
          (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search keyword"
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th id="couponCode" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Coupon Code</div>
      </th>
      <th id="created" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Created</div>
      </th>
      <th id="expiration" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Expiration</div>
      </th>
      <th id="value" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Value</div>
      </th>
      <th id="status" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Status</div>
      </th>
      <th id="actions" class="table-col-width-large">
        <div class="p-d-flex p-jc-between p-ai-center">Actions</div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-coupon>
    <tr>
      <td>
        <span>{{ coupon.couponCode }}</span>
      </td>
      <td>
        <span>{{ coupon.created | date : "dd/MM/yyyy" }}</span>
      </td>
      <td>
        <span>{{ coupon.expirationDate | date : "dd/MM/yyyy" }}</span>
      </td>
      <td>
        <span>{{ coupon.amount }}</span>
      </td>
      <td>
        <span>{{ coupon.isActive | status }}</span>
      </td>
      <td>
        <p-button
          label="Edit"
          styleClass="p-button-warning p-button-sm"
          icon="pi pi-file-edit"
          iconPos="right"
          (onClick)="showEditCoupon(coupon)"
        ></p-button>
        <p-button
          *ngIf="coupon.isActive"
          label="Disable"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-lock"
          iconPos="right"
          (onClick)="swapEnableCoupon(coupon)"
        ></p-button>
        <p-button
          *ngIf="!coupon.isActive"
          label="Enable"
          styleClass="p-button-primary p-button-sm"
          icon="pi pi-lock-open"
          iconPos="right"
          (onClick)="swapEnableCoupon(coupon)"
        ></p-button>
        <p-button
          label="Delete"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-trash"
          iconPos="right"
          (onClick)="showDeleteCoupon(coupon)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No coupons found.</td>
    </tr>
  </ng-template>
</p-table>
